export default __webpack_public_path__ + "static/media/Gif_MoordER.adc371bd.gif";